import React from 'react';

/* packages */
import { ModuleTitle } from '../../util-atomic-design';
/* packages */

const index = props => {
  return <ModuleTitle>
    Search Result - Company
  </ModuleTitle>
}

export default index;
